import getPriceDisplay from './getPriceDisplay'

export default getPriceDisplay
